function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import crypto, { isCryptoKey } from './webcrypto.js';
import invalidKeyInput from '../lib/invalid_key_input.js';
import { encodeBase64, decodeBase64 } from './base64url.js';
import formatPEM from '../lib/format_pem.js';
import { JOSENotSupported } from '../util/errors.js';
import { types } from './is_key_like.js';
var genericExport = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(keyType, keyFormat, key) {
    var _t, _t2, _t3, _t4, _t5, _t6, _t7;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (isCryptoKey(key)) {
            _context.n = 1;
            break;
          }
          throw new TypeError(invalidKeyInput.apply(void 0, [key].concat(_toConsumableArray(types))));
        case 1:
          if (key.extractable) {
            _context.n = 2;
            break;
          }
          throw new TypeError('CryptoKey is not extractable');
        case 2:
          if (!(key.type !== keyType)) {
            _context.n = 3;
            break;
          }
          throw new TypeError("key is not a ".concat(keyType, " key"));
        case 3:
          _t = formatPEM;
          _t2 = encodeBase64;
          _t3 = Uint8Array;
          _context.n = 4;
          return crypto.subtle.exportKey(keyFormat, key);
        case 4:
          _t4 = _context.v;
          _t5 = new _t3(_t4);
          _t6 = _t2(_t5);
          _t7 = "".concat(keyType.toUpperCase(), " KEY");
          return _context.a(2, _t(_t6, _t7));
      }
    }, _callee);
  }));
  return function genericExport(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export var toSPKI = function toSPKI(key) {
  return genericExport('public', 'spki', key);
};
export var toPKCS8 = function toPKCS8(key) {
  return genericExport('private', 'pkcs8', key);
};
var _findOid = function findOid(keyData, oid) {
  var from = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  if (from === 0) {
    oid.unshift(oid.length);
    oid.unshift(0x06);
  }
  var i = keyData.indexOf(oid[0], from);
  if (i === -1) return false;
  var sub = keyData.subarray(i, i + oid.length);
  if (sub.length !== oid.length) return false;
  return sub.every(function (value, index) {
    return value === oid[index];
  }) || _findOid(keyData, oid, i + 1);
};
var getNamedCurve = function getNamedCurve(keyData) {
  switch (true) {
    case _findOid(keyData, [0x2a, 0x86, 0x48, 0xce, 0x3d, 0x03, 0x01, 0x07]):
      return 'P-256';
    case _findOid(keyData, [0x2b, 0x81, 0x04, 0x00, 0x22]):
      return 'P-384';
    case _findOid(keyData, [0x2b, 0x81, 0x04, 0x00, 0x23]):
      return 'P-521';
    case _findOid(keyData, [0x2b, 0x65, 0x6e]):
      return 'X25519';
    case _findOid(keyData, [0x2b, 0x65, 0x6f]):
      return 'X448';
    case _findOid(keyData, [0x2b, 0x65, 0x70]):
      return 'Ed25519';
    case _findOid(keyData, [0x2b, 0x65, 0x71]):
      return 'Ed448';
    default:
      throw new JOSENotSupported('Invalid or unsupported EC Key Curve or OKP Key Sub Type');
  }
};
var genericImport = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(replace, keyFormat, pem, alg, options) {
    var _options$extractable;
    var algorithm, keyUsages, keyData, isPublic, namedCurve, _t8;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          keyData = new Uint8Array(atob(pem.replace(replace, '')).split('').map(function (c) {
            return c.charCodeAt(0);
          }));
          isPublic = keyFormat === 'spki';
          _t8 = alg;
          _context2.n = _t8 === 'PS256' ? 1 : _t8 === 'PS384' ? 1 : _t8 === 'PS512' ? 1 : _t8 === 'RS256' ? 2 : _t8 === 'RS384' ? 2 : _t8 === 'RS512' ? 2 : _t8 === 'RSA-OAEP' ? 3 : _t8 === 'RSA-OAEP-256' ? 3 : _t8 === 'RSA-OAEP-384' ? 3 : _t8 === 'RSA-OAEP-512' ? 3 : _t8 === 'ES256' ? 4 : _t8 === 'ES384' ? 5 : _t8 === 'ES512' ? 6 : _t8 === 'ECDH-ES' ? 7 : _t8 === 'ECDH-ES+A128KW' ? 7 : _t8 === 'ECDH-ES+A192KW' ? 7 : _t8 === 'ECDH-ES+A256KW' ? 7 : _t8 === 'Ed25519' ? 8 : _t8 === 'EdDSA' ? 9 : 10;
          break;
        case 1:
          algorithm = {
            name: 'RSA-PSS',
            hash: "SHA-".concat(alg.slice(-3))
          };
          keyUsages = isPublic ? ['verify'] : ['sign'];
          return _context2.a(3, 11);
        case 2:
          algorithm = {
            name: 'RSASSA-PKCS1-v1_5',
            hash: "SHA-".concat(alg.slice(-3))
          };
          keyUsages = isPublic ? ['verify'] : ['sign'];
          return _context2.a(3, 11);
        case 3:
          algorithm = {
            name: 'RSA-OAEP',
            hash: "SHA-".concat(parseInt(alg.slice(-3), 10) || 1)
          };
          keyUsages = isPublic ? ['encrypt', 'wrapKey'] : ['decrypt', 'unwrapKey'];
          return _context2.a(3, 11);
        case 4:
          algorithm = {
            name: 'ECDSA',
            namedCurve: 'P-256'
          };
          keyUsages = isPublic ? ['verify'] : ['sign'];
          return _context2.a(3, 11);
        case 5:
          algorithm = {
            name: 'ECDSA',
            namedCurve: 'P-384'
          };
          keyUsages = isPublic ? ['verify'] : ['sign'];
          return _context2.a(3, 11);
        case 6:
          algorithm = {
            name: 'ECDSA',
            namedCurve: 'P-521'
          };
          keyUsages = isPublic ? ['verify'] : ['sign'];
          return _context2.a(3, 11);
        case 7:
          namedCurve = getNamedCurve(keyData);
          algorithm = namedCurve.startsWith('P-') ? {
            name: 'ECDH',
            namedCurve: namedCurve
          } : {
            name: namedCurve
          };
          keyUsages = isPublic ? [] : ['deriveBits'];
          return _context2.a(3, 11);
        case 8:
          algorithm = {
            name: 'Ed25519'
          };
          keyUsages = isPublic ? ['verify'] : ['sign'];
          return _context2.a(3, 11);
        case 9:
          algorithm = {
            name: getNamedCurve(keyData)
          };
          keyUsages = isPublic ? ['verify'] : ['sign'];
          return _context2.a(3, 11);
        case 10:
          throw new JOSENotSupported('Invalid or unsupported "alg" (Algorithm) value');
        case 11:
          return _context2.a(2, crypto.subtle.importKey(keyFormat, keyData, algorithm, (_options$extractable = options === null || options === void 0 ? void 0 : options.extractable) !== null && _options$extractable !== void 0 ? _options$extractable : false, keyUsages));
      }
    }, _callee2);
  }));
  return function genericImport(_x4, _x5, _x6, _x7, _x8) {
    return _ref2.apply(this, arguments);
  };
}();
export var fromPKCS8 = function fromPKCS8(pem, alg, options) {
  return genericImport(/(?:-----(?:BEGIN|END) PRIVATE KEY-----|\s)/g, 'pkcs8', pem, alg, options);
};
export var fromSPKI = function fromSPKI(pem, alg, options) {
  return genericImport(/(?:-----(?:BEGIN|END) PUBLIC KEY-----|\s)/g, 'spki', pem, alg, options);
};
function getElement(seq) {
  var result = [];
  var next = 0;
  while (next < seq.length) {
    var nextPart = parseElement(seq.subarray(next));
    result.push(nextPart);
    next += nextPart.byteLength;
  }
  return result;
}
function parseElement(bytes) {
  var position = 0;
  var tag = bytes[0] & 0x1f;
  position++;
  if (tag === 0x1f) {
    tag = 0;
    while (bytes[position] >= 0x80) {
      tag = tag * 128 + bytes[position] - 0x80;
      position++;
    }
    tag = tag * 128 + bytes[position] - 0x80;
    position++;
  }
  var length = 0;
  if (bytes[position] < 0x80) {
    length = bytes[position];
    position++;
  } else if (length === 0x80) {
    length = 0;
    while (bytes[position + length] !== 0 || bytes[position + length + 1] !== 0) {
      if (length > bytes.byteLength) {
        throw new TypeError('invalid indefinite form length');
      }
      length++;
    }
    var _byteLength = position + length + 2;
    return {
      byteLength: _byteLength,
      contents: bytes.subarray(position, position + length),
      raw: bytes.subarray(0, _byteLength)
    };
  } else {
    var numberOfDigits = bytes[position] & 0x7f;
    position++;
    length = 0;
    for (var i = 0; i < numberOfDigits; i++) {
      length = length * 256 + bytes[position];
      position++;
    }
  }
  var byteLength = position + length;
  return {
    byteLength: byteLength,
    contents: bytes.subarray(position, byteLength),
    raw: bytes.subarray(0, byteLength)
  };
}
function spkiFromX509(buf) {
  var tbsCertificate = getElement(getElement(parseElement(buf).contents)[0].contents);
  return encodeBase64(tbsCertificate[tbsCertificate[0].raw[0] === 0xa0 ? 6 : 5].raw);
}
function getSPKI(x509) {
  var pem = x509.replace(/(?:-----(?:BEGIN|END) CERTIFICATE-----|\s)/g, '');
  var raw = decodeBase64(pem);
  return formatPEM(spkiFromX509(raw), 'PUBLIC KEY');
}
export var fromX509 = function fromX509(pem, alg, options) {
  var spki;
  try {
    spki = getSPKI(pem);
  } catch (cause) {
    throw new TypeError('Failed to parse the X.509 certificate', {
      cause: cause
    });
  }
  return fromSPKI(spki, alg, options);
};